import { render, staticRenderFns } from "./QuickviewReview.vue?vue&type=template&id=14db6e1e&scoped=true&"
import script from "./QuickviewReview.vue?vue&type=script&lang=js&"
export * from "./QuickviewReview.vue?vue&type=script&lang=js&"
import style0 from "./QuickviewReview.vue?vue&type=style&index=0&id=14db6e1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14db6e1e",
  null
  
)

export default component.exports